import { render, staticRenderFns } from "./view_OurBooks.vue?vue&type=template&id=f9fc052c&scoped=true&"
import script from "./view_OurBooks.vue?vue&type=script&lang=js&"
export * from "./view_OurBooks.vue?vue&type=script&lang=js&"
import style0 from "./view_OurBooks.vue?vue&type=style&index=0&id=f9fc052c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fc052c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
